import { UsersService } from './../../../@core/backend/common/services/users.service';
/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbDialogService, NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserStore } from '../../../@core/stores/user.store';
import { SettingsData } from '../../../@core/interfaces/common/settings';
import { User,UserData } from '../../../@core/interfaces/common/users';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApplicationProcessApi } from '../../../@core/backend/common/api/applicationProcess.api';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  firstForm: FormGroup;
  userPictureOnly: boolean = false;
  user: User;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = this.getMenuItems();
  language: any;
  personalDetails: any;
  userid: any;

  constructor(private sidebarService: NbSidebarService,
              private fb: FormBuilder,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userStore: UserStore,
              private router : Router,
              private settingsService: SettingsData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private processapi: ApplicationProcessApi,
              private dialogService: NbDialogService,
              private usersService:UserData) {
  }

  getMenuItems() {
    const userLink = this.user ?  '/pages/users/current/' : '';
    return [
      { title: 'Profile', link: userLink, queryParams: { profile: true } },
      { title: 'Change Password',link: '/auth/reset-password' },
      { title: 'Log out', link: '/auth/logout' },
    ];
  }

  ngOnInit() {
    this.getPreviewData();
    this.currentTheme = this.themeService.currentTheme;

    // this.userStore.onUserStateChange()
    //   .pipe(
    //     takeUntil(this.destroy$),
    //   )
    //   .subscribe((user: User) => {
    //     this.user = user;
    //     this.userMenu = this.getMenuItems();
    //   });
    this.usersService.getCurrentUser().pipe(takeUntil(this.destroy$),)
    .subscribe((user) => {
      this.user = user;
      this.userMenu = this.getMenuItems();
    })

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
      this.firstForm = this.fb.group({
        languagectrl: this.fb.control('')
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.userStore.setSetting(themeName);
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }
  demo(){
    this.router.navigateByUrl('/pages/faq');
  }

 
  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  onChange(value) {
    this.language = this.firstForm.controls.languagectrl.value;
    this.processapi.appliedForlanguage(value,this.userid).subscribe(data => {
      if (data['status'] == 200) {
        this.ngOnInit()
      }


    });
  }
  getPreviewData(){    
    this.processapi.getPreviewData().subscribe(data=>{
      this.personalDetails = data['data']['personalDetails'];
      this.userid = this.personalDetails.id
    })
  } 
}
